import { render, staticRenderFns } from "./GroupSwitchModal.vue?vue&type=template&id=63188809&scoped=true"
import script from "./GroupSwitchModal.vue?vue&type=script&lang=js"
export * from "./GroupSwitchModal.vue?vue&type=script&lang=js"
import style0 from "./GroupSwitchModal.vue?vue&type=style&index=0&id=63188809&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63188809",
  null
  
)

export default component.exports